import {useQuery} from 'react-query';
import axiosClient from '../../axios-client';

export interface FacilitySwitcherItem {
    id: number;
    name: string;
    is_group: boolean;
    is_demo: boolean;
    group_names?: string[];
}

export const FACILITY_SWITCHER_MIN_CHARS = 2;

/** Recherche du sélecteur super admin (GET /super-admin/facility-switcher). */
export function useFacilitySwitcherSearch(search: string, enabled: boolean) {
    const term = search.trim();

    return useQuery<FacilitySwitcherItem[]>(
        ['super-admin', 'facility-switcher', term],
        async () => {
            const {data} = await axiosClient.get('/super-admin/facility-switcher', {params: {search: term}});
            return (data.data ?? data) as FacilitySwitcherItem[];
        },
        {
            enabled: enabled && term.length >= FACILITY_SWITCHER_MIN_CHARS,
            keepPreviousData: true,
            staleTime: 30_000,
        },
    );
}
